<template>
  <div class="mapSearch">
    <div class="gwTitle">搜索条件</div>
    <div class="xx">
      <el-select
        v-model="keyWords"
        filterable
        remote
        reserve-keyword
        placeholder="请输入道路名称"
        :remote-method="remoteMethod"
        @change="changeRoad"
        value-key="id"
      >
        <el-option
          v-for="item in roadList"
          :key="item.id"
          :label="item.roadName"
          :value="item"
        >
        </el-option>
      </el-select>
    </div>

    <div
      style="
        height: calc(100% - 100px);
        margin-top: 20px;
        overflow: hidden;
        overflow-y: auto;
      "
    ></div>
  </div>
</template>

<script>
import CommonApi from "@/api/common";
export default {
  data() {
    return {
      keyWords: "",
      roadList: [],
    };
  },
  methods: {
    remoteMethod(query) {
      CommonApi.queryRoadList({
        roadName: query,
        townCode: "",
      }).then((res) => {
        if (res.data.code === 200) {
          this.roadList = res.data.data;
        } else {
          this.roadList = [];
        }
      });
    },
    changeRoad(value) {
      this.$emit("getGw", { townCode: value.townCode, roadId: value.id });
    },
  },
};
</script>

<style lang="scss" scoped>
.mapSearch {
  height: 100%;
  .gwTitle {
    font-size: 20px;
    height: 30px;
    line-height: 30px;
    font-weight: 600;
  }
  .xx {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    align-items: center;

    .xxTitle {
      margin-right: 20px;
      width: 40px;
    }
  }
  .resultItem {
    margin: 10px 0;
    .resultTitle {
      font-size: 18px;
      font-weight: 600;
    }
    .resultAddress {
      margin-top: 6px;
      font-size: 14px;
    }
  }
}
</style>
